function getTheColor(string) {
  switch (string) {
  case 'High-Level Resistance':
    return 'high';
  case 'High-Level':
    return 'high';
  default:
    return 'normal';
  }
}

function makeMutationsArray(mutations) {
  return Object.keys(mutations)
    .reduce((acc, cur) => {
      return acc.concat(
        Object.keys(mutations[cur])
          .reduce((a, c) => {
            return a.concat(`${cur.toUpperCase()}:${c}`);
          }, []));
    }, []);
}

export {
  getTheColor,
  makeMutationsArray
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js